import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {color} from "@khanacademy/wonder-blocks-tokens";

import PageRoot from "#app-shell-package/page-root.tsx";

import Details from "./details.tsx";
import Footer from "./footer.tsx";
import Hero from "./hero.tsx";
import Overview from "./overview.tsx";
import type {Images, Strings} from "./types.ts";

type Props = {
    strings: Strings;
    images: Images;
};

export default function BNCCPage({strings, images}: Props): React.ReactElement {
    return (
        <PageRoot settings={{title: strings.htmlTitle}}>
            <View style={styles.page}>
                <Hero strings={strings} images={images} />
                <Overview strings={strings} images={images} />
                <Details strings={strings} images={images} />
                <Footer strings={strings} images={images} />
            </View>
        </PageRoot>
    );
}

const styles = StyleSheet.create({
    page: {
        width: "100%",
        color: color.offBlack,
    },
});
